import { getCmsPageData } from '@/apis/apiCms';
import { getMindData } from '@/apis/login/login.api';
import { ModuleInstance } from '@/apis/types/cms';
import DownloadApp from '@/assets/icons/downloadApp.svg';
import MindFaster from '@/assets/icons/MindFaster.svg';
import MindOffer from '@/assets/icons/MindOffer.svg';
import MindPriceDrop from '@/assets/icons/MindPriceDrop.svg';
import qrcode from '@/assets/icons/qrcode2.png';
import FooterData from '@/common-components-src/const/footer';
import loginEnum from '@/intl-jdi-common-ssr/constants/loginConfig';
import PAGE_TYPE from '@/constants/pageType';
import { getServerTranslation } from '@/i18n/index';
import cn from 'clsx';
import _ from 'lodash';
import Image from 'next/image';
import { Home_Page_Code } from '../../../../constants/cms';
import styles from './benefitBar.module.scss';
import BenefitBarClient from './BenefitBarClient';

interface Props {
  pageType: PAGE_TYPE;
  pageCode: string;
}

const getGlobalMindData = async () => {
  const mindDataResult = await getMindData(loginEnum.MindScopeEnum.HOME_PAGE);
  if (mindDataResult?.success && mindDataResult?.data) {
    return { mindList: mindDataResult?.data, title: '' };
  } else {
    return { mindList: undefined, title: '' };
  }
};

const getHomeMindData = async (pageCode: string) => {
  const pageData = await getCmsPageData(pageCode);
  const mentalModule = _.flattenDeep(pageData?.data?.floors?.map((f) => f?.moduleInstances))?.find(
    (m) => m.moduleCode === 'platform-pc-mental',
  ) as ModuleInstance;
  const mindList = mentalModule?.dataBatch?.mental?.map((m: any) => m?.mental);
  const title = mentalModule?.dataStyle?.style?.['show-type']?.title;
  return { mindList, title };
};

const BenefitBarWrap = async ({ pageType, pageCode }: Props) => {
  let mindList, title;
  if (pageType === PAGE_TYPE.HOME || pageType === PAGE_TYPE.MINI_HOME || pageCode) {
    ({ mindList, title } = await getHomeMindData(pageCode));
    if (!mindList || mindList.length === 0) {
      ({ mindList, title } = await getHomeMindData(Home_Page_Code));
    }
  } else {
    ({ mindList, title } = await getGlobalMindData());
  }

  const { t } = await getServerTranslation();
  const { googleDownload, AppDownload } = FooterData;

  return (
    <div className={styles.benefitBarWrap} id='benefit-bar-wrap'>
      <div className={styles.w}>
        <div className={styles.benefitBar}>
          <BenefitBarClient mindList={mindList} title={title} />
          <div className={styles.tagWrap}>
            <div className={cn(styles.tag, styles.downloadWrap)}>
              <DownloadApp className={styles.download} />
              <div className={styles.txt}>
                <div className={styles.title}>{t('benefitWrap.downloadAPP')}</div>
              </div>
              <div className={styles.downloadDropdownLayer}>
                <div className={styles.downloadBox}>
                  <div className={styles.left}>
                    <a className={styles.downLoadBtn} href={AppDownload} target='_blank'>
                      <img src='https://st.joy-sourcing.com/website/home/appStore.png' alt='' />
                    </a>
                    <a className={styles.downLoadBtn} href={googleDownload} target='_blank'>
                      <img src='https://st.joy-sourcing.com/website/home/googlePlay.png' alt='' />
                    </a>
                  </div>
                  <div className={styles.right}>
                    <div className={styles.scan}>
                      <div className={styles.qrcode}>
                        <Image src={qrcode.src} width={120} height={120} alt='qr' />
                      </div>
                      <div className={styles.txt}>{t('benefitWrap.qrCode')}</div>
                    </div>
                  </div>
                </div>
                <div className={styles.mind}>
                  <ul>
                    <li className={styles.mindItem}>
                      <MindPriceDrop />
                      <span className={styles.txt}>{t('benefitWrap.marketing1')}</span>
                    </li>
                    <li className={styles.mindItem}>
                      <MindFaster />
                      <span className={styles.txt}>{t('benefitWrap.marketing2')}</span>
                    </li>
                    <li className={styles.mindItem}>
                      <MindOffer />
                      <span className={styles.txt}>{t('benefitWrap.marketing3')}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitBarWrap;
